// Generiert von scripts/write-build-env.mjs – nicht von Hand ändern.
export interface BuildEnv {
  sentryDsn: string;
  sentryEnvironment: string;
}

export const buildEnv: BuildEnv = {
  "sentryDsn": "https://eea71520eec94f2d902042f82ce28139@errors.construct202.ch/3",
  "sentryEnvironment": "dev"
};
